import './App.css';
import Index from './views/index/index.js';
import Admin from './views/admin/admin.js';
import { BrowserRouter, Route, Routes } from 'react-router-dom';


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route exact path='/admin' element={<Admin/>} />
          <Route exact path='/' element={<Index/>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
